<template>
	<svg
		width="19px"
		height="16px"
		viewBox="0 0 19 16"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
			<g
				transform="translate(-54.000000, -40.000000)"
				stroke="#67686A"
				stroke-width="1.3"
			>
				<g transform="translate(17.000000, 17.000000)">
					<path
						d="M46.6738793,24.2155607 L46.6738793,28.6308884 C43.8544385,28.6308884 41.0349984,28.6308884 38.2155583,28.6308884 L38.2155583,28.6308884 C38.0965088,28.6308884 38,28.7273974 38,28.8464467 L38,33.5921488 C38,33.7111945 38.0965088,33.8077071 38.2155583,33.8077071 C41.0349984,33.8077071 43.8544385,33.8077071 46.6738793,33.8077071 L46.6738793,37.7844417 C46.6738793,37.9034874 46.7703848,38 46.8894376,38 C46.9418111,38 46.9923883,37.9809303 47.0317349,37.9463619 L54.72246,31.1877547 C54.8118807,31.1091672 54.8206683,30.9729667 54.7420829,30.8835416 C54.7361479,30.8767889 54.7297961,30.8704148 54.7230707,30.8644554 L47.0323456,24.0541806 C46.9432123,23.9752564 46.8069794,23.983528 46.7280563,24.0726558 C46.6931502,24.1120752 46.6738793,24.1629076 46.6738793,24.2155607 Z"
					></path>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'ForwardIcon',
}
</script>

<style lang="scss" scoped></style>
